import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twisto/styles';

export const elementImage = (theme: Theme) => css`
  margin-bottom: ${theme.spacing[16]};

  ${breakpoint.up('sm')} {
    margin-bottom: ${theme.spacing[32]};
  }
`;
